import { Controller } from '@hotwired/stimulus';
import SET_MAP from '../../config/mapbox/setMap';
import { FILL_LAYER_ID, LINE_LAYER_ID, SOURCE_ID, filterZone, FILL_LAYER_PAINT, LINE_LAYER_PAINT } from './mapbox_options'

export default class extends Controller {
  static targets = ['geocoder', 'inZoneAlert', 'zoneResult', 'cityCard']

  static values = {
    publicKey: String,
    style: String,
    regionLat: String,
    regionLng: String,
    zoom: Number,
    regionId: String
  }

  connect() {
    this.handleMapSettings()
    this.handleLayers()
    this.handleGeocoder()
    this.handleMapEvent()
  }

  handleMapSettings() {
    this.adminZoneMap = SET_MAP.initMap(this.publicKeyValue, [this.regionLngValue, this.regionLatValue], 9, this.styleValue, 'admin-map-cities')
    this.geocoder = SET_MAP.initGeocoder()
    this.adminZoneMap.addControl(this.geocoder);
  }

  handleLayers() {
    this.adminZoneMap.on('load', async () => {
      const response = await fetch(`/admin/regions/${this.regionIdValue}/cities/geojson`)
      const geojson = await response.json()
      this.adminZoneMap.addSource(SOURCE_ID, { type: 'geojson', data: geojson })

      this.adminZoneMap.addLayer({
        id: FILL_LAYER_ID,
        type: 'fill',
        source: SOURCE_ID,
        filter: filterZone('quarter'),
        paint: FILL_LAYER_PAINT
      })

      this.adminZoneMap.addLayer({
        id: LINE_LAYER_ID,
        type: 'line',
        source: SOURCE_ID,
        filter: filterZone('city'),
        paint: LINE_LAYER_PAINT
      })
    })
  }

  handleGeocoder() {
    this.geocoder.on('result', async (e) => {
      const [lng, lat] = e.result.center
      this.zoneResultTarget.textContent = ''
      this.inZoneAlertTarget.classList.remove('vesta-bg-red-20', 'vesta-bg-green-20')

      const response = await fetch(`/api/v1/quarters?lng=${lng}&lat=${lat}`)

      if (response.ok) {
        const data = await response.json()
        this.geocoderTarget.value = data.city_insee_code || ''
        this.filterCities()
        this.inZoneAlertTarget.classList.add('vesta-bg-green-20')
        this.zoneResultTarget.textContent = `Ce bien se trouve dans la zone de catégorie ${data.zone_category_id}`
      } else {
        this.inZoneAlertTarget.classList.add('vesta-bg-red-20')
        this.zoneResultTarget.textContent = 'Ce bien est hors zone'
      }
    })
  }

  handleMapEvent() {
    if (this.hasGeocoderTarget) {
      this.adminZoneMap.on('click', 'zone-region', (e) => {
        if (e.features.length > 0) {
          this.geocoderTarget.value = e.features[0].properties.insee_code
          this.filterCities();
        }
      });

      this.geocoderTarget.onkeyup = () => this.filterCities();
    }
  }

  filterCities = () => {
    const filter = this.geocoderTarget.value.toLowerCase();

    this.cityCardTargets.forEach(cityCard => {
      const name = cityCard.dataset.name;
      const inseeCode = cityCard.dataset.inseeCode;

      if ((name.toLowerCase().indexOf(filter) > -1) || (inseeCode.indexOf(filter) > -1)) {
        cityCard.style.display = "";
      } else cityCard.style.display = "none";
    });
  }
}
